import { z } from 'zod'
import { type QuickViewSelectItem } from '../../components/menus/quick-view-selector'
import { type ScanAnalysisState } from '../../utils/api-client/api-schemas'

export const ScanQuickViewIdSchema = z.enum(['scan-completed', 'scan-in-progress', 'scan-unanalyzed'])
export type ScanQuickViewId = z.infer<typeof ScanQuickViewIdSchema>

export type ScanQuickViewConfig = {
  id: ScanQuickViewId
  label: string
  analysisState: ScanAnalysisState
}

export const SCAN_QUICK_VIEW_CONFIGS: Record<ScanQuickViewId, ScanQuickViewConfig> = {
  'scan-completed': {
    id: 'scan-completed',
    label: 'Analyzed',
    analysisState: 'completed',
  },
  'scan-in-progress': {
    id: 'scan-in-progress',
    label: 'Analysis in progress',
    analysisState: 'in-progress',
  },
  'scan-unanalyzed': {
    id: 'scan-unanalyzed',
    label: 'Unanalyzed',
    analysisState: 'not-analyzed',
  },
}

export const DEFAULT_SCAN_QUICK_VIEW_ID: ScanQuickViewId = 'scan-completed'

export const SCAN_QUICK_VIEW_IDS = ScanQuickViewIdSchema.options

export function getScanQuickViewConfig(id: ScanQuickViewId): ScanQuickViewConfig {
  return SCAN_QUICK_VIEW_CONFIGS[id]
}

export function createScanQuickViewSelectItem(
  id: ScanQuickViewId,
  count?: number
): QuickViewSelectItem<ScanQuickViewId> {
  const config = getScanQuickViewConfig(id)
  return {
    value: id,
    label: config.label,
    count,
  }
}
